import React, { useState } from 'react';
import { ChevronRightSvg, FileSvg, FolderCloseSvg, FolderOpenSvg } from '../../assets/svgs';
import ButtonComponent from '../button';
import { CheckboxTreeActions, CheckboxTreeChildren, CheckboxTreeInput, CheckboxTreeLabel, CheckboxTreeNode, CheckboxTreeWrapper, ExpandIcon, LabelText } from './checkbox-tree.style';

const CHECKBOX_TREE_NODE = ({ node, handleCheckboxTreeChange, selectedValues, update, disabled, selectedDisabled }) => {
  const [isExpanded, setIsExpanded] = useState(update ? true : false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <CheckboxTreeNode>
      <CheckboxTreeLabel>
        {
          node.children && node.children.length > 0 && (
            <ExpandIcon onClick={toggleExpand}>
              <ChevronRightSvg className={isExpanded ? 'checkbox-tree-expand' : ''} />
            </ExpandIcon>
          )
        }
        <LabelText>
          <CheckboxTreeInput
            type="checkbox"
            onChange={(e) => handleCheckboxTreeChange(node.value, e.target.checked)}
            checked={selectedValues.includes(node.value)}
            disabled={disabled || selectedDisabled?.includes(node.value)}
          />
          {
            node.children && node.children.length > 0 ? (
              <>
                {
                  isExpanded ? <FolderOpenSvg /> : <FolderCloseSvg />
                }
              </>
            ) : (
              <FileSvg />
            )
          }
          {node.label}
        </LabelText>
      </CheckboxTreeLabel>
      {
        isExpanded && node.children && node.children.length > 0 && (
          <CheckboxTreeChildren>
            {
              node.children.map((child) => (
                <CHECKBOX_TREE_NODE
                  key={child.value}
                  node={child}
                  handleCheckboxTreeChange={handleCheckboxTreeChange}
                  selectedValues={selectedValues}
                  disabled={disabled}
                  update={update}
                  selectedDisabled={selectedDisabled}
                />
              ))
            }
          </CheckboxTreeChildren>
        )
      }
    </CheckboxTreeNode>
  );
};

const CheckboxTreeComponent = ({ nodes, handleCheckboxTreeChange, selectedValues, update, disabled, selectedDisabled }) => {
  const [isExpandedAll, setIsExpandedAll] = useState(update);

  return (
    <CheckboxTreeWrapper>
      <CheckboxTreeActions>
        <ButtonComponent
          label={isExpandedAll ? 'Collapse all' : 'Expand all'}
          outline
          onClick={() => setIsExpandedAll(!isExpandedAll)} size='small'
        />
      </CheckboxTreeActions>

      {
        nodes && nodes.length > 0 &&
        <div key={isExpandedAll}>
          {
            nodes.map((node) => (
              <CHECKBOX_TREE_NODE
                key={node?.value}
                node={node}
                handleCheckboxTreeChange={handleCheckboxTreeChange}
                selectedValues={selectedValues}
                update={isExpandedAll}
                disabled={disabled}
                selectedDisabled={selectedDisabled}
              />
            ))
          }
        </div>
      }
    </CheckboxTreeWrapper>
  );
};

export default CheckboxTreeComponent;
